const selectors = {
    wrapper: '.js-input-wrapper',
    inputFile: '.js-file',
    inputLabel: '.js-file-text'
};

const updateFileLabel = () => {
    const $file = $(selectors.inputFile);
    const defaultText = $(selectors.inputLabel).text();

    if (!$file.length) {
        return;
    }

    const updateLabel = (evt) => {
        const $this = $(evt.currentTarget);
        const $wrapper = $this.closest(selectors.wrapper);
        const $inputLabel = $wrapper.find(selectors.inputLabel);
        const fileName = evt.currentTarget.files[0]?.name ?? defaultText;

        $inputLabel.text(fileName);
    };

    $file.on('change', updateLabel);
};

export default updateFileLabel;
